import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vc-incoming-hero" }
const _hoisted_2 = { class: "vc-incoming-hero__purpose text-wrap" }
const _hoisted_3 = { class: "mb-16" }
const _hoisted_4 = { class: "vc-rail-cta-stack mt-auto pt-2" }

import { computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useCallStore } from '../stores/callStore'
import { apiClient } from '../services/apiClient'
import PatientBackground from '../components/PatientBackground.vue'
import { missedCallAvailabilityLine } from '@virtual-care/shared'

interface Props {
  sessionId?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MissedCallView',
  props: {
    sessionId: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()
const callStore = useCallStore()

const resolvedSessionId = computed(() =>
  callStore.sessionId ?? props.sessionId
)

const subtitle = computed(() => missedCallAvailabilityLine(callStore.callPurpose))

const handleAvailable = async () => {
  console.log('[MissedCallView] handleAvailable clicked, sessionId:', resolvedSessionId.value)
  if (resolvedSessionId.value) {
    try { await apiClient.respondAvailability(resolvedSessionId.value, 'available') } catch { /* best-effort */ }
  }
  router.push('/availability-confirm')
}

const handleCallBackLater = () => {
  console.log('[MissedCallView] handleCallBackLater clicked')
  router.push('/')
}

onMounted(() => {
  console.log('[MissedCallView] Mounted with sessionId:', resolvedSessionId.value, 'status:', callStore.status)
})

onBeforeUnmount(() => {
  console.log('[MissedCallView] Unmounting')
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_VBtnPrimary = _resolveComponent("VBtnPrimary")!
  const _component_VBtnTextDark = _resolveComponent("VBtnTextDark")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height bg-backgroundBase vc-incoming-root"
  }, {
    default: _withCtx(() => [
      _createVNode(PatientBackground),
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "vc-incoming-hero__title text-wrap" }, "A nurse just tried to contact you.", -1)),
        _createElementVNode("p", _hoisted_2, _toDisplayString(subtitle.value), 1)
      ]),
      _createVNode(_component_v_sheet, {
        class: "vc-incoming-panel d-flex flex-column bg-white",
        elevation: "24",
        height: "100%",
        rounded: "0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              class: "vc-rail__video-icon",
              color: "primary"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-video-plus-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "flex-grow-1",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VBtnPrimary, {
              block: "",
              class: "vc-incoming-action text-none",
              size: "x-large",
              onClick: handleAvailable
            }, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createTextVNode(" I'm Available ", -1)),
                _createVNode(_component_v_icon, {
                  end: "",
                  size: "large"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-check", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_VBtnTextDark, {
              block: "",
              class: "vc-incoming-decline text-none",
              size: "x-large",
              onClick: handleCallBackLater
            }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createTextVNode(" Call Back Later ", -1)),
                _createVNode(_component_v_icon, {
                  end: "",
                  color: "dark",
                  size: "large"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})